<template>
   <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Νεo Οχημα
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">Πληροφορίες Oχήματος</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="veh">
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  label="Αριθμός Κυκλοφορίας*"
                  :rules="[rules.required]"
                  v-model="newVehicle.PlateNumber"
                  required
                  class="toupper"
                  @input="newVehicle.PlateNumber = newVehicle.PlateNumber.toUpperCase()"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  label="Αρθμός Πλαισίου*"
                  v-model="newVehicle.Vin"
                  hint="Αρ. Πλαισίου 18 χαρακτήρες"
                  :rules="[rules.vin, rules.required]"
                  required
                  class="toupper"
                  @input="newVehicle.Vin = newVehicle.Vin.toUpperCase()"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
                >
              <v-text-field
                v-model="newVehicle.Year"
                label="Ετος κατασκευής"
                type="tel"
                prepend-icon="mdi-calendar"
                :rules="[rules.year]"
              ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  :items="['VOLVO', 'MAN', 'MERCEDES-BENZ', 'DAF', 'SCANIA', 'NISSAN', 'ISUZU', 'IVECO', 'TOYOTA', 'JCB', 'MAZDA', 'DAIMLER CHRYSL', 'RENAULT', 'VOLKSWAGEN', 'FORD', 'ASTRA', 'BOVA', 'DAEWOO', 'HYUNDAI','ISUZU','KIA','MITSUBISHI','NEOPLAN','SETRA','STEYR','TATRA','CITROEN','LAND ROVER', 'JEEP', 'MAZDA',  'SUZUKI','PEUGEOT', 'SAF', 'ROR', 'OTHER']"
                  label="Μάρκα*"
                  v-model="newVehicle.Make"
                ></v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-combobox
                  :items="['Truck', 'Van', 'Bus', 'Trailer', 'PickUp', 'Box', 'Refrigerator', 'Tanker', 'Crane', 'Garbage Pickup', 'Dump Truck', 'Flatbed', 'Tow', 'Mixer', 'Tractor', 'Forklift']"
                  label="Τύπος*"
                  v-model="newVehicle.VehType"
                ></v-combobox>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-autocomplete
                  :items="customers"
                  label="Πελάτης"
                  item-text="Name"
                  item-value="Cid"
                  v-model="newVehicle.OwnerId"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
          <small>*indicates required field</small>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            Κλείσιμο
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="saveVehicle"
          >
            Αποθήκευση
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>

<script>

  export default {

   computed: {
    },
    props: {
        cid: {
          required: true
      },
      newVehicle: {
        type: Object,
        default() {
          return {
        PlateNumber: "",
        Vin: "",
        Year: "",
        Make: "",
        OwnerId: this.cid,
        VehType: "Truck"
         }
        }
      }
    },
    data() {
      return {
        menu: false,
        dialog: false,
        customers: [],
        saveDisable: false,
        rules: {
          required: value => !!value || 'Required.',
          vin: value => value.length == 17 || 'VIN must be 17 characters long',
          year: value => 1960 <= parseInt(value) || 'year',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          },
        },
     }
    },
    async mounted() {
      if (!this.$store.allcustomers) {

      const resp = await this.$api.get("/quotes/customers");
      this.customers = resp.data;
      this.$store.allcustomers = this.customers;
      } else {
        this.customers = this.$store.allcustomers;
      }
      // console.log(this.cid);
      this.newVehicle.OwnerId = this.cid;
    },

    methods: {
    async saveVehicle () {
      console.log(this.newVehicle);
      if (this.$refs.veh.validate()) {
        const resp = await this.$api.post("/repairs/vehicles", this.newVehicle);
        if (resp.status == 201) {
          console.log(resp);
        } else
        {
          alert(resp.data.detail);
        }

        this.dialog = false;
      }
    },
    },
  }

</script>

<style>

.toupper input {
  text-transform: uppercase;
}
</style>
